import React, { useState } from "react";
import "./chatWindow.css";
import SearchBar from "./SearchBar/SearchBar";
import AddChat from "./AddChat/AddChat";
import ChatUserContainer from "./ChatUserContainer/ChatUserContainer";
import { WHITE, PRIMARYLIGHT, DARKMAIN } from "../../Theme/colorConstant";
import { useSelector } from "react-redux";
import SwitchTabs from "../Utils/SwitchTabs";
import { Typography, } from "@material-ui/core";


const ChatWindow = React.memo(() => {
  const [tabValue, setTabValue] = useState("People");
  const [contactsLoaded, setContactsLoaded] = useState(false);
  const [groupsLoaded, setGroupsLoaded] = useState(false);
  const { isNightMode } = useSelector((store) => {
    return {
      isNightMode: store.app.mode || false,
    };
  });
  return (
    <div
      className="chat__window"
      style={{
        background: isNightMode ? DARKMAIN : WHITE,
        borderRight: `1px solid ${isNightMode ? DARKMAIN : PRIMARYLIGHT}`
      }}
    >
      <div className="chatWindow__header" style={{
        background: isNightMode ? DARKMAIN : PRIMARYLIGHT,
      }}>
        <SearchBar />
        <AddChat />
      </div>
      <div className="switch__tabs" style={{ marginBottom: "0.5rem" }}>
        <SwitchTabs
          setTabValue={setTabValue}
          tabValue={tabValue}
          setContactsLoaded={setContactsLoaded}
          setGroupsLoaded={setGroupsLoaded}
        />
      </div>
      <ChatUserContainer
        tabValue={tabValue}
        contactsLoaded={contactsLoaded}
        groupsLoaded={groupsLoaded}
      />
      <footer className="footer">
        <Typography style={{ fontSize: '15px' }}>Powered by Arc Inventador</Typography>
      </footer>
    </div>
  );
});

export default React.memo(ChatWindow);
